import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { HttpService } from '../../services';
import { InputBaseComponent } from '../input-base.component';

@Component({
    selector: 'ct-select',
    templateUrl: './ct-select.component.html',
    styleUrls: ['./ct-select.component.css'],
    host: {
        '[id]': 'getId()',
        '[hidden]': 'getHidden()',
        '[class]': "'form-group'"
    }
})
export class CtSelectComponent extends InputBaseComponent {

    @ViewChild('el') formControl: ElementRef;
    @ViewChild('search') search: ElementRef;
    private fieldValue: string;
    private fieldText: string;
    private anyOption: boolean;
    private multiple: boolean;
    public options: any[] = [];
    private optionsList: string;
    private actions: any = [];
    private adnList: any = [];
    typeAhead: boolean;

    constructor() {
        super();
    }

    ngAfterViewInit() {
        this.setMetadataPropertyValue('initValue', this.getValue());
        this.setInitValue(this.getValue());
        this.loadListCode();
    }

    loadListCode() {
        if (this.optionsList !== undefined && this.optionsList !== null && this.optionsList !== "null") {
            if (this.optionsList && this.optionsList !== "") {
                let list = this.getListFromCache(this.optionsList);

                if (list) {
                    this.options = list;
                    this.setInternalValue();
                } else {
                    this.isLoading = true;

                    this.httpService.scheduleRequest('get', HttpService.ENDPOINT + '/api/List/' + this.optionsList, (response) => {
                        if (typeof (response) === 'string')
                            response = JSON.parse(response);

                        this.adnList = response;
                        let isStatic = false;

                        if (this.adnList && this.adnList.length > 0)
                            isStatic = this.utilService.getStringAttribute('@IS_STATIC', this.adnList[0].ArrayEntities.List) === 'Y';

                        this.options = this.utilService.convertAdnToSelectOptions(response, this.fieldValue, this.fieldText);

                        this.setListToCache(this.optionsList, this.options, isStatic);
                        this.setInternalValue();
                        setTimeout(() => {
                            this.isLoading = false;
                        });

                    }, null, null, this.getId(), true, this.optionsList);
                }
            }
        } else {
            this.options = this.utilService.convertAdnToSelectOptions(this.adnList, this.fieldValue, this.fieldText);
            this.setInternalValue();
            setTimeout(() => {
                this.isLoading = false;
            });
        }

        setTimeout(() => {
            this.isLoading = false;
        },5000);
    }

    /*public onChange(): void {
        this.event2('onChange');
    }*/

    private getListFromCache(listCode: string): any[] {
        let listStr = localStorage.getItem(listCode);
        let isStatic = listStr !== null;
        let list = null;

        if (!listStr)
            listStr = sessionStorage.getItem(listCode);

        if (listStr) {
            list = JSON.parse(listStr);

            let diffTime = Math.abs(new Date().getTime() - new Date(list.created).getTime());

            if (isStatic)
                diffTime = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); /*dias*/
            else
                diffTime = Math.ceil(diffTime / (1000 * 60)); /*minutos*/

            if (diffTime <= (isStatic ? 7 /*dias*/ : 5 /*minutos*/))
                list = list.values;
            else {
                localStorage.removeItem(listCode);
                sessionStorage.removeItem(listCode);
                list = null;
            }
        }

        return list;
    }

    private setListToCache(listCode: string, listValues: any[], isStatic: boolean = false): void {
        if (isStatic)
            localStorage.setItem(listCode, JSON.stringify({ values: listValues, created: new Date().toDateString() }));
        else
            sessionStorage.setItem(listCode, JSON.stringify({ values: listValues, created: new Date().getTime() }));
    }

    private setInternalValue(): void {
        if (!this.options) {
            let metaInitVal = this.getMetadataPropertyValue('initValue');
            this.setValue(null);

            if (!metaInitVal)
                this.setInitValue(null);
            else
                this.setInitValue(metaInitVal);
        } else {
            if (this.anyOption) {
                this.setValue(this.getInitValue());
            } else {
                if (!this.getInitValue())
                    this.setInitValue(this.options[0].value);

                this.setValue(this.getInitValue());
            }
        }
    }


    filter() {
        let searchValue = this.search.nativeElement.value;
        var fleet = this.formControl.nativeElement;
        for (var i = 0; i < fleet.length; i++) {
            var txt = fleet.options[i].text;
            if (txt.substring(0, searchValue?.length).toLowerCase() !== searchValue.toLowerCase() && searchValue.trim() !== "") {
                fleet.options[i].style.display = 'none';
            } else {
                fleet.options[i].style.display = 'list-item';
            }
        }
        // if (searchValue?.length >= 2) {
        //     fleet.style.display = 'block';
        // } else {
        //     fleet.style.display = 'block';
        // }

        if (!searchValue) {
            this.formControl.nativeElement.value = null;
            this.setValue(null);
        };
    }

    hide() {
        var fleet = this.formControl.nativeElement;
        fleet.style.display = 'none';
    }

    show() {
        var fleet = this.formControl.nativeElement;
        fleet.style.display = 'block';
    }

    selectOption() {
        if (this.formControl.nativeElement.value) {
            this.search.nativeElement.value = this.formControl.nativeElement.selectedOptions[0].text;
        }

        this.hide();
    }

    getTypeAhead(): boolean { return this.typeAhead }
    getFieldValue(): string { return this.fieldValue }
    getFieldText(): string { return this.fieldText }
    getAnyOption(): boolean { return this.anyOption }
    getMultiple(): boolean { return this.multiple }
    getOptions(): any[] { return this.options }
    getOptionsList(): string { return this.optionsList }
    getActions(): any { return this.actions }
    getIsLoading(): boolean { return this.isLoading }
    getValue() {
        let value = super.getValue();
        return value instanceof Array ? value[0] : value;
    }

    setTypeAhead(typeAhead: boolean) { this.typeAhead = typeAhead }
    setFieldValue(fieldValue: string): void { this.fieldValue = fieldValue }
    setFieldText(fieldText: string): void { this.fieldText = fieldText }
    setAnyOption(anyOption: boolean): void { this.anyOption = anyOption }
    setMultiple(multiple: boolean): void { this.multiple = multiple }
    setOptions(options: any): void { this.options = options }
    setOptionsList(optionsList: string) { this.optionsList = optionsList }
    setActions(actions: any) { this.actions = actions }
    setValue(value: any): void {
        if (value instanceof Array)
            value = value[0];
        super.setValue([value]);
    }
}

